<template>
  <div
    id="lottieIcon"
    class="lottie-icon"
    :width="width"
  />
</template>
<script setup lang="ts">
import {onMounted, inject, computed, type Ref} from "vue"
import animateJSON from "@/tools/json-animation.ts"
import {AnimationFileNameEnum} from "./types"

const props = withDefaults(
  defineProps<{
    animation?: AnimationFileNameEnum
    width?: string
  }>(),
  {
    animation: AnimationFileNameEnum.expirenza,
    width: "100%",
  }
)
const dialogRef = inject<Ref<{options: {props: Record<string, any>}}>>("dialogRef")
const filename = computed(() => dialogRef?.value?.options.props?.animation || props.animation)
async function startAnimation(elem: string) {
  try {
    const animation = await import(`@/assets/animation/${filename.value}.json`).then(
      (m) => m.default
    )
    const anim = animateJSON(elem, animation, 20)
    anim?.play()
  } catch (error) {
    console.log(error)
  }
}
onMounted(() => {
  if (filename.value) {
    startAnimation("lottieIcon")
  }
})
</script>
<style lang="less" scoped>
.lottie-icon {
  width: 100%;
  max-width: 224px;
  margin: auto;
}
</style>
